import {
  Backdrop,
  Card,
  Checkbox,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
// location: frontend/qiankun/upstyledpkgs/tui.image-editor-3.15.3
// must yarn remove tui-image-editor @toast-ui/react-image-editor
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ImageEditor from "@toast-ui/react-image-editor";
import { Upload } from "antd";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import { nanoid } from "nanoid";
import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import toast from "react-hot-toast";
import api from "services/api";
import "tui-image-editor/dist/tui-image-editor.css";
import useImage from "use-image";
import { dataURLtoFile, getImageDimensions, resizeImg } from "utils/imageHelper";
import CloseIcon from "@mui/icons-material/Close";

const EditImageModal = ({
  visible,
  handleClose,
  sketchData,
  setSketchData,
  setIsDirty,
  stageRef,
  sketchWidth,
  sketchHeight,
  ailab_id,
}) => {
  const [loading, setLoading] = useState(false);
  const editImgRef = useRef(null);
  var container = document.querySelector("#image-editor-parent");

  let uri = "";
  if (stageRef?.current) {
    uri = stageRef.current?.toDataURL();
  }

  //https://github.com/nhn/tui.image-editor/blob/master/apps/image-editor/src/js/ui/theme/standard.js
  const myTheme = {
    "header.display": "none",
    //'common.backgroundColor': '#e0e0e0',
    //'submenu.backgroundColor': '#e0e0e0',
  };

  const saveEditImg = async () => {
    setLoading(true);
    try {
      const editorInstance = editImgRef.current.getInstance();
      const file = dataURLtoFile(editorInstance.toDataURL(), nanoid());
      var blob = await resizeImg(file, sketchWidth, sketchHeight);
      var file2 = new File([blob], file.name, { type: file.type });
      const uploadedImg = await api.uploads
        .create([file2], {}, ailab_id ? ailab_id : "draw-image")
        .then(({ data }) => {
          const uploaded = data.uploads.map(({ url }) => url);
          return uploaded;
        })
        .catch((err) => {
          console.log(err);
          toast.error("Save image failed!");
        });
      if (uploadedImg.length === 1) {
        var url = uploadedImg[0];
        const { width, height } = await getImageDimensions(url);
        setSketchData({ ...sketchData, imgurl: url, width: width, height: height });
        setIsDirty(true);
      }
      setLoading(false);
      handleClose();
    } catch (err) {
      console.log(err);
      setLoading(false);

      toast.error("Failed to save image!");
    }
  };

  return (
    <Dialog
      open={visible}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={(e, reason) => {
        handleClose();
      }}
      fullScreen
      sx={{ zIndex: 13000 }}
    >
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={loading}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
        <SuiTypography variant="h6" fontWeight="medium" color="info">
          Saving ...
        </SuiTypography>
      </Backdrop>
      <AppBar sx={{ position: "relative" }} color="primary">
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <SuiTypography sx={{ ml: 2, flex: 1 }} variant="h6" color="white">
            Image Editor
          </SuiTypography>
          <SuiButton autoFocus color="inherit" onClick={saveEditImg}>
            Save & Exit
          </SuiButton>
        </Toolbar>
      </AppBar>
      <div id="image-editor-parent" style={{ width: "100%", height: "100%" }}>
        <SuiBox
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ width: "100%", height: "100%" }}
        >
          {uri && (
            <ImageEditor
              ref={editImgRef}
              includeUI={{
                theme: myTheme,
                loadImage: {
                  path: uri,
                  name: "image",
                },
                uiSize: {
                  width: "100%",
                  height: "100%",
                },
                menuBarPosition: "right",
                menu: [
                  "crop",
                  "rotate",
                  "draw",
                  "eraser",
                  "shape",
                  "icon",
                  "text",
                  "mask",
                  "filter",
                ],
                initMenu: "draw",
              }}
              cssMaxHeight={700}
              cssMaxWidth={1200}
              usageStatistics={false}
              selectionStyle={{
                cornerSize: 5,
                rotatingPointOffset: 70,
              }}
            />
          )}
        </SuiBox>
      </div>
    </Dialog>
  );
};

export default EditImageModal;
